import Vue from 'vue'

Vue.mixin({
  methods: {
    initForm(form, props) {
      form.resetFields()
      if (props) {
        Object.keys(props).forEach(key => {
          form.getFieldDecorator(key)
        })
        this.$nextTick(() => {
          form.setFieldsValue(props)
        })
      }
    }
  }
})
